module.exports = __webpack_public_path__ + "img/gateway2.93834895.png";